<ng-container *ngIf="sessionStatus$ | async as status">
    <div *ngIf="status?.isExpiringSoon" class="session-expiration-banner">
        <!-- Icon -->
        <span class="ham-icon icon">
            <i class="exclamation-outline-icon"></i>
        </span>

        <!-- Warning message -->
        <div class="banner-text">
            {{ getMessage(status) }}
        </div>

        <!-- Spacer -->
        <div class="flex-spacer"></div>

        <!-- Action buttons -->
        <div class="banner-actions">
            <button class="banner-button secondary" (click)="onDismiss()" type="button">
                {{ 'aumico_licence_banner_dismiss_button' | i18next }}
            </button>
            <button class="banner-button primary" (click)="onReAuthenticate()" type="button">
                {{ 'aumico_session_warning_reauth_button' | i18next }}
            </button>
        </div>
    </div>
</ng-container>
